import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const AddGlyph = /*#__PURE__*/createElement("g", {
  id: "add"
}, /*#__PURE__*/createElement("path", {
  d: "M67.5,40.5h-24v-24a1.5,1.5,0,0,0-3,0v24h-24a1.5,1.5,0,0,0,0,3h24v24a1.5,1.5,0,0,0,3,0v-24h24a1.5,1.5,0,0,0,0-3Z"
}));
const Add = createSvg({
  name: 'add',
  path: AddGlyph
});

export default Add;
export { AddGlyph };
